<ng-template #packBlock>
    <p-button
        [pTooltip]="
            disabledCheck()
                ? ('document.packing-config-disabled-follow-up-document' | translate)
                : ''
        "
        [label]="'document.packing-config-disabled-follow-up-document' | translate"
        (onClick)="changeToFollowUpDocument()"
        [attr.data-testid]="'packing-config-widget-button-blocking'"
    />
</ng-template>

<blockable-div
    #packBlock
    class="h-full"
    [blocked]="disabledCheck()"
    [blockUi]="packBlock"
    [dataTestId]="'packing-config-widget-blockable-div'"
>
    <app-packing-config-widget
        #packingConfigWidget
        [documents]="[model]"
        (savedPackagingDLI)="onSavedPackagingDLI($event)"
        (deletedPackagingDLI)="onDeletedPackagingDLI($event)"
        (savedPacking)="onSavedPacking()"
        (deletedPacking)="onDeletedPacking()"
        (completePackingAndTransferDocument)="onCompletePackingAndTransferDocument()"
    ></app-packing-config-widget>
</blockable-div>
